import Popover from "@hydrologiq/shared/chakra/Popover"
import { Asset, Customer } from "@hydrologiq/gql-experience/graphql"
import StatusBadge from "@hydrologiq/shared/asset/status/StatusBadge"
import EntityPopoverList from "@hydrologiq/shared/components/popovers/EntityPopoverList"
import DataConnectionIndicator from "@hydrologiq/shared/data-connections/DataConnectionIndicator"

interface CustomerAssetsPopupProps {
  customer?: Customer
  assetCount: number
  assets?: Asset[]
  name?: string
}

function CustomerAssetsPopup({
  customer,
  assetCount,
  assets: overrideAssets,
  name: overrideName,
}: CustomerAssetsPopupProps) {
  let allAssets = overrideAssets || []
  let name = overrideName || "Customer"
  if (customer && !overrideAssets) {
    const assetsOnHire = customer?.assetsOnHire || []
    allAssets = assetsOnHire.length > 0 ? assetsOnHire : customer?.sites?.flatMap((site) => site.assets || []) || []
    name = customer.name
  }

  const items = allAssets.map((asset: any) => ({
    id: asset.id,
    name: asset.name || "Unnamed Asset",
    href: `/assets/${asset.id}`,
    openExternal: true,
    prefix: <DataConnectionIndicator asset={asset} />,
    badge: asset.status ? <StatusBadge asset={asset} minWidth="5.25rem" /> : undefined,
  }))

  return (
    <Popover
      placement="bottom-end"
      additionalContent={assetCount.toString()}
      ariaLabel={`View ${assetCount} assets for ${name}`}
      width="max-content"
      minWidth="22.5rem"
      maxWidth="min(45rem, calc(100vw - 3rem))"
      disabled={assetCount === 0}
      showArrow={true}
      closeOnOutside
    >
      <EntityPopoverList
        title="Assets"
        count={assetCount}
        items={items}
        emptyText="No assets on hire"
      />
    </Popover>
  )
}

export default CustomerAssetsPopup
